import actions from './actions.js'

export default {
    actions,
}
